<template>
  <div>
    <b-row>
      <b-col md="5">
        <autocomplete-tax v-model="service.fiscal.tributes" />
      </b-col>
      <b-col md="3">
        <autocomplete-cst v-model="service.fiscal.cst" />
      </b-col>
      <b-col md="2">
        <Input
          :labelBold="true"
          label="Código IBPT"
          id="ibpt"
          v-model="service.fiscal.ibpt"
          :on-key-down="ibptKeyUp"
          :maxlength="9"
        />
      </b-col>
      <b-col md="2">
        <Input
          :labelBold="true"
          label="CNAE Fiscal"
          id="cnae"
          v-model="service.fiscal.cnae"
          :maxlength="30"
        />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col md="5">
        <autocomplete-nbs v-model="service.fiscal.nbs" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Input } from '@/components/Form';
import AutocompleteTax from '@/modules/Fiscal/modules/Shared/components/AutocompleteTax';
import AutocompleteCst from '@/modules/Fiscal/modules/Shared/components/AutocompleteCST';
import AutocompleteNbs from '@/modules/Fiscal/modules/Shared/components/AutocompleteNBS';
import { mapState } from 'vuex';

export default {
  name: 'FormTax',
  components: {
    AutocompleteTax,
    AutocompleteCst,
    AutocompleteNbs,
    Input,
  },
  computed: {
    ...mapState('service', ['service']),
  },
  methods: {
    ibptKeyUp(e) {
      if (!/^[0-9.]$/.test(e.key) && e.key.length === 1) {
        e.preventDefault();
      }
    },
  },
};
</script>
